import EVImg from '@components/EVImg';
import { FC } from 'react';
import { Header, ImageWrapper, StyledBlock, Subheader, SubheaderWrapper } from './styles';

interface DevelopmentHeaderProps {
  header?: string;
  subheaders: string | string[];
  img?: string;
}

const DevelopmentHeader: FC<DevelopmentHeaderProps> = ({ header, subheaders, img }) => {
  return (
    <StyledBlock>
      {img && (
        <ImageWrapper>
          <EVImg
            src={img}
            alt={header}
            width={220}
            height={110}
            layout="responsive"
            objectFit="contain"
          />
        </ImageWrapper>
      )}
      {header && <Header>{header}</Header>}
      {subheaders && (
        <SubheaderWrapper>
          {
            //if it's an array, map over it, if it's a single string, just render it
            Array.isArray(subheaders) ? (
              subheaders.map((subheader, index) => (
                <Subheader
                  key={index}
                  className={index == subheaders.length - 1 ? '' : 'with-bullet'}
                >
                  {subheader}
                </Subheader>
              ))
            ) : (
              <Subheader>{subheaders}</Subheader>
            )
          }
        </SubheaderWrapper>
      )}
    </StyledBlock>
  );
};

export default DevelopmentHeader;
